// extracted by mini-css-extract-plugin
export default {"link":"wD-z","disabled":"xD-z"};